import { useMutation } from "react-query";

import { type IUser } from "@jti/rest-api-types";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { ReferralApi } from "../../../services";

export const useReferralVerifyCode = (user: IUser) => {
  return useMutation(MUTATION_KEYS.verifyReferralCode, ({ referralCode }: { referralCode: string }) => {
    return ReferralApi.init().verifyCode(referralCode, user.ciam_token);
  });
};
